import { render, staticRenderFns } from "./AlertCustomerStock.vue?vue&type=template&id=6e864c84&"
import script from "./AlertCustomerStock.vue?vue&type=script&lang=js&"
export * from "./AlertCustomerStock.vue?vue&type=script&lang=js&"
import style0 from "./AlertCustomerStock.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AlertCustomerStock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports